module.exports = __webpack_public_path__ + "media/application/images/svgs/link-77b41985042ae2e793337789a4747c4e.svg";